import React from 'react';
import './ColumnVisibilityDropdown.css';
import { ColumnVisibilityDropdownProps } from '../types';

const ColumnVisibilityDropdown: React.FC<ColumnVisibilityDropdownProps> = ({
  columns,
  visibleColumns,
  onColumnToggle,
  onClose,
}) => {
  return (
    <div className="column-visibility-dropdown">
      <div className="dropdown-header">
        <h3>Show/Hide Columns</h3>
        <button className="close-button" onClick={onClose}>
          &times;
        </button>
      </div>
      <div className="column-list">
        {columns.map((column, index) => (
          <label key={index} className="column-item">
            <input
              type="checkbox"
              checked={visibleColumns.includes(column.key)}
              onChange={() => onColumnToggle(column.key)}
            />
            <span>{column.label}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default ColumnVisibilityDropdown;
